export const NetworkingRoomPreview = () => {
  return (
    <div
      className="overflow-hidden rounded-lg border border-slate-800/80 bg-black"
      aria-hidden="true"
    >
      <img
        src="/preview/everyone-in-the-room.png"
        alt=""
        width={640}
        height={400}
        loading="lazy"
        decoding="async"
        className="block w-full"
      />
      <p className="border-t border-slate-800/80 px-3 py-2.5 text-center text-xs font-medium leading-snug text-emerald-400/90">
        Come find someone to talk to.
      </p>
    </div>
  );
};
